import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { PlusOutlined, FileTextOutlined, EditOutlined } from '@ant-design/icons';

import { RenderBlogs,CreateBlogForm, EditBlogForm  } from '../components';


const { Title } = Typography;

const Blog = () => {
  const [activeTab, setActiveTab] = useState('view');
  const [editingBlog, setEditingBlog] = useState(null);

  // Handle editing a blog
  const handleEditBlog = (blog) => {
    setEditingBlog(blog);
    setActiveTab('edit');
  };

  // Handle closing edit mode
  const handleCloseEdit = () => {
    setEditingBlog(null);
    setActiveTab('view');
  };

  const tabItems = [
    {
      key: 'view',
      label: (
        <span className="flex items-center space-x-2">
          <FileTextOutlined />
          <span>My Blogs</span>
        </span>
      ),
      children: <RenderBlogs onEdit={handleEditBlog} />,
    },
    {
      key: 'create',
      label: (
        <span className="flex items-center space-x-2">
          <PlusOutlined />
          <span>Create Blog</span>
        </span>
      ),
      children: <CreateBlogForm />,
    },
  ];

  // Add edit tab when editing
  if (editingBlog) {
    tabItems.push({
      key: 'edit',
      label: (
        <span className="flex items-center space-x-2">
          <EditOutlined />
          <span>Edit Blog</span>
        </span>
      ),
      children: <EditBlogForm blog={editingBlog} onClose={handleCloseEdit} />,
    });
  }

  return (
    <div className="min-h-screen bg-bg-primary">
      {/* Page Header */}
      <div className="bg-white border-b border-border-light">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex items-center space-x-3">
            <FileTextOutlined className="text-3xl text-accent-blue" />
            <div>
              <Title level={1} className="m-0 text-text-primary font-bold">
                Blog Management
              </Title>
              <p className="text-text-secondary mt-1 text-lg">
                Create, manage, and publish your blog posts
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
          className="tabs"
        />
      </div>

      
    </div>
  );
};

export default Blog;